import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Lottie from 'react-lottie';
import ThumbsUpAnimation from '../../../../animations/like-thumb-up-outline.json';

const SuccessMsg = (props) => {
  /*
  function openTermsInNewTab(e) {
    e.preventDefault();
    window.open(props.termsLink, '_blank').focus();
  }
  */

  return (
    <div className='payment-cg-success-msg'>
      <div className='img-wrapper'>
        {/* <Lottie options={{animationData: ThumbsUpAnimation, loop: false}} width={200} height={200} /> */}
        <Image alt='icon-like' src={require('../images/icon-like.svg')} />
      </div>
      <div className='text-wrapper'>
        <p>הכרטיס מאושר</p>
        {/* <p>אשרו את עיקרי ההסכם ולחצו על המשך</p> */}
      </div>

      {/* <Checkbox id='terms-checkbox' onCheck={props.onClickTermsCheckbox} onUncheck={props.ocClickTermsCheckbox} checked={props.isTermsCheckboxChecked}>           אני מאשר\ת את
        <a href="#" onClick={(e) => { openTermsInNewTab(e) }}> תנאי השימוש ועיקרי ההסכם </a>
      </Checkbox >
      {props.isDisplayCheckboxErrorMsg && <p className='checkbox-error-msg'>אנא אשר את תנאי השימוש ועקרי ההסכם</p>} */}
    </div>
  );
};

export default SuccessMsg;
